import AdminDashboard from '@/views/tableau-de-bord/dashboard-admin';
import InfirmierDashboard from '@/views/tableau-de-bord/dashboard-infirmier';
import MedecinDashboard from '@/views/tableau-de-bord/dashboard-medecin';
import LaboratinDashboard from '@/views/tableau-de-bord/dashboard-laboratin';
import MdtDashboard from '@/views/tableau-de-bord/dashboard-mdt';
import SageFemmeDashboard from '@/views/tableau-de-bord/dashboard-sage-femme';

export default {
    name: 'tableau-de-bord',
    components: {
        AdminDashboard,
        InfirmierDashboard,
        MedecinDashboard,
        LaboratinDashboard,
        MdtDashboard,
        SageFemmeDashboard
    },
    props: [],
    data() {
        return {
            user_role: '',
            active_role: '',
        }
    },
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },
    mounted() {
        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;
        }

        // if (
        //     this.user_role != 'ROLE_INFIRMIER' && this.user_role != 'ROLE_ADMINISTRATEUR' &&
        //     this.user_role != 'ROLE_MEDECIN' && this.user_role != 'ROLE_TECH_SUP_LABO' &&
        //     this.user_role != 'ROLE_MEDECIN_TRAVAIL' && this.user_role != "ROLE_SAGE_FEMME"
        // ) {
        //     this.$router.push({ "path": "/login" })
        // }

        this.active_role = this.activeRole.nom

        // for(let i = 0; i < this.consultationsEnAttente.length; i++) {
        //     this.drp_menu_class[i] = 'drp_menu_pos'+this.consultationsEnAttente[i].id;
        // }
    },
    methods: {

    }
}